import React, { useEffect } from 'react';
import style from '../../styling/general.module.scss';
import { Cross1Icon } from '@radix-ui/react-icons';

const LeaveModal = ({ closeModal }) => {

  useEffect(() => {
    const lock = () => {
      document.body.style.overflowY = 'hidden';
    }
    lock();

    return () => {
      document.body.style.overflowY = 'initial';
    }
  }, [])

  return (
    <div className={style.modalOverlay} onClick={() => closeModal()}>
      <div className={style.modal}>
        <Cross1Icon className={style.crossIcon} onClick={() => closeModal()} />
        <h1 className={style.modalTitle}>Nieuwe collega!</h1>
        <p style={{ fontSize: '22px' }}>
          Beste patiënten,<br/><br/>
          Vanaf 1/1/2026 verwelkomen wij dr. Wirawan Evelyne als nieuwe huisarts in onze praktijk.
          Dr. Wirawan is vanaf volgend jaar samen met ons team klaar om u de best mogelijke zorg te bieden.
        </p>
      </div>
    </div>
  )
};

export default LeaveModal;
